import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from '@angular/common';  
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";

@Component({
  selector: "app-error-message",
  templateUrl: "./error-message.component.html",
  styleUrls: ["./error-message.component.css"]
})
export class ErrorMessageComponent implements OnInit{
  private m_error     : boolean = false;
  private m_errorMsg  : string = "";
  
  constructor(private router:Router ) {
  }
  
  ngOnInit(): void {
  }

  error()     : boolean { return this.m_error;}
  errorMsg()  : string  { return this.m_errorMsg;}

  handleError(error:HttpErrorResponse){
    if(error.status == 401){
      this.router.navigate([`/ErrorPage`],{ state: { error: error.error.Message } });   
    }
    else{
      this.m_error     = true;
      this.m_errorMsg = error.error.Message;

    }
  }

  setError(p_msg : string){
    this.m_error    = true;
    this.m_errorMsg = p_msg;
  }

  clearError(){
    this.m_error    = false;
    this.m_errorMsg = "";
  }  

}
